import { render, staticRenderFns } from "./BulletinDocumentsComponent.vue?vue&type=template&id=5034cbce&scoped=true&"
import script from "./BulletinDocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./BulletinDocumentsComponent.vue?vue&type=script&lang=js&"
import style0 from "./BulletinDocumentsComponent.vue?vue&type=style&index=0&id=5034cbce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5034cbce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5034cbce')) {
      api.createRecord('5034cbce', component.options)
    } else {
      api.reload('5034cbce', component.options)
    }
    module.hot.accept("./BulletinDocumentsComponent.vue?vue&type=template&id=5034cbce&scoped=true&", function () {
      api.rerender('5034cbce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/bulletin/BulletinDocumentsComponent.vue"
export default component.exports